(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.collection-list-section .collection-list__model').forEach((modelWrap) => {
    const pauseIdleMotion = () => modelWrap.classList.add('collection-list__model--idle-paused');
    modelWrap.addEventListener('pointerdown', pauseIdleMotion, { passive: true });
  });

  document.querySelectorAll('.collection-list-section model-viewer').forEach((mv) => {
    mv.setAttribute('disable-zoom', '');
    mv.setAttribute('interaction-prompt', 'none');
    mv.removeAttribute('poster');
    mv.style.backgroundColor = 'transparent';
    mv.style.setProperty('--poster-color', 'transparent');

    const reveal = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          mv.classList.add('is-loaded');
        });
      });
    };

    if (mv.loaded) {
      reveal();
    } else {
      mv.addEventListener('load', reveal, { once: true });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  const setupCollectionInfinite = (root) => {
    const infinite = root.querySelector('[data-collection-infinite]');
    const grid = root.querySelector('[data-collection-grid]');
    const sentinel = root.querySelector('[data-collection-sentinel]');
    if (!infinite || !grid || !sentinel) return;
    if (infinite.dataset.bound === 'true') return;
    infinite.dataset.bound = 'true';

    const sectionId = infinite.dataset.sectionId;
    const statusEl = infinite.querySelector('[data-collection-infinite-status]');
    let loading = false;
    let nextUrl = infinite.dataset.nextUrl || '';

    const applyCardOffsets = (cards, startIndex) => {
      cards.forEach((card, i) => {
        const mod = (startIndex + i) % 4;
        const isEven = mod === 1 || mod === 3;
        card.classList.toggle('collection-page__card--even', isEven);
        card.classList.toggle('collection-page__card--odd', !isEven);
      });
    };

    const loadNext = async () => {
      if (loading || !nextUrl) return;
      loading = true;
      infinite.classList.add('is-loading');
      if (statusEl) statusEl.hidden = false;

      try {
        const url = new URL(nextUrl, window.location.origin);
        if (sectionId) url.searchParams.set('section_id', sectionId);

        const response = await fetch(url.toString());
        if (!response.ok) throw new Error(`Failed to load page: ${response.status}`);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-collection-grid]');
        const newInfinite = doc.querySelector('[data-collection-infinite]');
        if (!newGrid) throw new Error('Missing product grid in response');

        const newCards = Array.from(newGrid.querySelectorAll('.collection-page__card'));
        const startIndex = grid.querySelectorAll('.collection-page__card').length;
        applyCardOffsets(newCards, startIndex);
        newCards.forEach((card) => grid.appendChild(card));

        nextUrl = newInfinite?.dataset.nextUrl || '';
        if (nextUrl) {
          infinite.dataset.nextUrl = nextUrl;
        } else {
          infinite.removeAttribute('data-next-url');
          infinite.classList.add('collection-page__infinite--done');
          observer.disconnect();
        }
      } catch (error) {
        console.error(error);
      } finally {
        loading = false;
        infinite.classList.remove('is-loading');
        if (statusEl) statusEl.hidden = true;
      }
    };

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
          loadNext();
        }
      },
      { rootMargin: '400px 0px' }
    );

    observer.observe(sentinel);
  };

  document.querySelectorAll('.collection-page').forEach(setupCollectionInfinite);

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('.collection-page') || event.target.closest?.('.collection-page');
    if (root) {
      const infinite = root.querySelector('[data-collection-infinite]');
      if (infinite) infinite.dataset.bound = 'false';
      setupCollectionInfinite(root);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.contact-form-section__form').forEach((form) => {
    const sectionRoot = form.closest('.contact-form-section');
    if (!sectionRoot) return;

    const idSuffix = form.id?.replace('ContactForm-', '') || '';
    const nameHidden = sectionRoot.querySelector(`#ContactFormName-${idSuffix}`);
    const first = sectionRoot.querySelector(`#ContactFirstName-${idSuffix}`);
    const last = sectionRoot.querySelector(`#ContactLastName-${idSuffix}`);

    form.addEventListener('submit', () => {
      if (!nameHidden || !first || !last) return;
      const parts = [first.value.trim(), last.value.trim()].filter(Boolean);
      nameHidden.value = parts.join(' ');
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["marquee"] && !Shopify.designMode) return;
  try {
    
  const setupMarquee = (root) => {
    const viewport = root.querySelector('.marquee__viewport');
    const track = root.querySelector('.marquee__track');
    const group = track?.querySelector('.marquee__group');
    if (!viewport || !track || !group) return;

    track.classList.remove('is-ready');

    // Persist the original Liquid sequence so resizes don't compound clones
    if (!group.dataset.baseHtml) {
      group.dataset.baseHtml = group.innerHTML.trim();
    }
    const baseHTML = group.dataset.baseHtml;
    if (!baseHTML) return;

    track.querySelectorAll('.marquee__group').forEach((g, index) => {
      if (index > 0) g.remove();
    });

    group.innerHTML = baseHTML;
    group.removeAttribute('aria-hidden');

    const targetWidth = Math.max(viewport.offsetWidth, 1) * 2;
    let guard = 0;

    // Repeat until one group is at least 2× the viewport — no trailing blank gap
    while (group.scrollWidth < targetWidth && guard < 30) {
      group.insertAdjacentHTML('beforeend', baseHTML);
      guard += 1;
    }

    const clone = group.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('data-base-html');
    clone.querySelectorAll('[id]').forEach((el) => el.removeAttribute('id'));
    track.appendChild(clone);

    // Scale duration with content width so filling the track doesn't make it feel faster
    if (!track.dataset.baseDuration) {
      track.dataset.baseDuration = String(
        parseFloat(track.style.getPropertyValue('--marquee-duration')) || 60
      );
    }
    const baseDuration = parseFloat(track.dataset.baseDuration) || 60;
    const widthScale = Math.max(group.scrollWidth / Math.max(viewport.offsetWidth, 1), 1);
    track.style.setProperty('--marquee-duration', `${baseDuration * widthScale}s`);

    track.classList.add('is-ready');
  };

  const marquees = () => document.querySelectorAll('.marquee');

  marquees().forEach(setupMarquee);

  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      marquees().forEach(setupMarquee);
    }, 150);
  });

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector?.('.marquee') || event.target.closest?.('.marquee');
    if (root) setupMarquee(root);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-card-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-card-carousel [data-product-card-carousel-cta]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const href = btn.getAttribute('data-href');
      if (href) window.location.assign(href);
    });
  });

  document.querySelectorAll('.product-card-carousel__track-wrapper').forEach((wrapper) => {
    const DRAG_THRESHOLD = 5;
    let isPointerDown = false;
    let isDragging = false;
    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;

    wrapper.addEventListener('pointerdown', (event) => {
      if (event.pointerType !== 'mouse') return;
      if (event.button !== 0) return;
      isPointerDown = true;
      isDragging = false;
      pointerId = event.pointerId;
      startX = event.clientX;
      startScrollLeft = wrapper.scrollLeft;
    });

    wrapper.addEventListener('pointermove', (event) => {
      if (!isPointerDown || event.pointerId !== pointerId) return;
      const dx = event.clientX - startX;
      if (!isDragging) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        isDragging = true;
        wrapper.classList.add('is-dragging');
        try {
          wrapper.setPointerCapture(pointerId);
        } catch (_) {}
      }
      event.preventDefault();
      wrapper.scrollLeft = startScrollLeft - dx;
    });

    function endDrag(event) {
      if (!isPointerDown) return;
      if (event && pointerId !== null && event.pointerId !== pointerId) return;
      const wasDragging = isDragging;
      isPointerDown = false;
      isDragging = false;
      try {
        if (pointerId !== null) wrapper.releasePointerCapture(pointerId);
      } catch (_) {}
      pointerId = null;
      if (wasDragging) {
        wrapper.classList.remove('is-dragging');
        const suppress = (clickEvent) => {
          clickEvent.preventDefault();
          clickEvent.stopPropagation();
        };
        wrapper.addEventListener('click', suppress, { capture: true, once: true });
      }
    }

    wrapper.addEventListener('pointerup', endDrag);
    wrapper.addEventListener('pointercancel', endDrag);
    wrapper.addEventListener('pointerleave', endDrag);
    wrapper.addEventListener('dragstart', (event) => event.preventDefault());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel-product"] && !Shopify.designMode) return;
  try {
    
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  document.querySelectorAll('.product-page-carousel .product-page-carousel__model model-viewer').forEach((mv) => {
    if (reduceMotion) {
      mv.removeAttribute('auto-rotate');
    }
    mv.setAttribute('disable-zoom', '');
    mv.setAttribute('interaction-prompt', 'none');
    mv.removeAttribute('poster');
    mv.style.backgroundColor = 'transparent';
    mv.style.setProperty('--poster-color', 'transparent');

    const reveal = () => {
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          mv.classList.add('is-loaded');
        });
      });
    };

    if (mv.loaded) {
      reveal();
    } else {
      mv.addEventListener('load', reveal, { once: true });
    }
  });

  document.querySelectorAll('.product-page-carousel .product-page-carousel__thumbnails').forEach((track) => {
    let pointerId = null;
    let startX = 0;
    let startScrollLeft = 0;
    let isDragging = false;
    let scrollRaf = null;
    let pendingScrollLeft = 0;
    const dragThreshold = 8;

    const applyScroll = () => {
      track.scrollLeft = pendingScrollLeft;
      scrollRaf = null;
    };

    const onPointerDown = (e) => {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      pointerId = e.pointerId;
      startX = e.clientX;
      startScrollLeft = track.scrollLeft;
      isDragging = false;
    };

    const onPointerMove = (e) => {
      if (e.pointerId !== pointerId) return;

      const dx = e.clientX - startX;

      if (!isDragging) {
        if (Math.abs(dx) < dragThreshold) return;
        isDragging = true;
        track.classList.add('is-dragging');
        track.setPointerCapture(pointerId);
      }

      e.preventDefault();
      pendingScrollLeft = startScrollLeft - dx;
      if (!scrollRaf) {
        scrollRaf = requestAnimationFrame(applyScroll);
      }
    };

    const suppressClick = (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      track.removeEventListener('click', suppressClick, true);
    };

    const finishPointer = (e) => {
      if (e.pointerId !== pointerId) return;

      if (scrollRaf) {
        cancelAnimationFrame(scrollRaf);
        scrollRaf = null;
        track.scrollLeft = pendingScrollLeft;
      }

      if (isDragging) {
        if (track.hasPointerCapture(pointerId)) {
          track.releasePointerCapture(pointerId);
        }
        track.classList.remove('is-dragging');
        track.addEventListener('click', suppressClick, true);
      }

      pointerId = null;
      isDragging = false;
    };

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', finishPointer);
    track.addEventListener('pointercancel', finishPointer);
    track.addEventListener('dragstart', (e) => e.preventDefault());
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.product-carousel').forEach((carousel) => {
    const slides = carousel.querySelectorAll('.product-carousel__slide');
    const bgSlides = carousel.querySelectorAll('.product-carousel__section-bg-slide');
    const thumbnails = carousel.querySelectorAll('.product-carousel__thumbnail');
    const thumbnailStrip = carousel.querySelector('.product-carousel__thumbnails');
    const prevBtn = carousel.querySelector('[data-carousel-prev]');
    const nextBtn = carousel.querySelector('[data-carousel-next]');
    let activeIndex = 0;
    const totalSlides = slides.length;
    const TRANSITION_MS = 600;
    const AUTOPLAY_MS = 5000;
    let autoplayTimer = null;
    let autoplayDelayTimer = null;
    const resetTimers = new WeakMap();

    const html = document.documentElement;
    const hasAgeGate = html.classList.contains('has-age-gate');

    function ageGatePending() {
      return hasAgeGate && !html.classList.contains('age-verified');
    }

    function prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function clearResetTimer(slide) {
      const t = resetTimers.get(slide);
      if (t != null) {
        clearTimeout(t);
        resetTimers.delete(slide);
      }
    }

    function snapToRight(slide) {
      clearResetTimer(slide);
      slide.classList.remove('product-carousel__slide--leaving');
      slide.classList.add('product-carousel__slide--reset');
      // Force reflow so the transition-less state is committed before we remove the reset class.
      void slide.offsetWidth;
      requestAnimationFrame(() => {
        slide.classList.remove('product-carousel__slide--reset');
      });
    }

    function scrollThumbnailIntoView(index) {
      if (!thumbnailStrip) return;
      const thumb = thumbnails[index];
      if (!thumb) return;
      const target = thumb.offsetLeft - (thumbnailStrip.clientWidth - thumb.offsetWidth) / 2;
      thumbnailStrip.scrollTo({
        left: Math.max(0, target),
        behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      });
    }

    function goToSlide(index) {
      const newIndex = ((index % totalSlides) + totalSlides) % totalSlides;
      if (newIndex === activeIndex) {
        restartAutoplay();
        return;
      }
      const previousIndex = activeIndex;
      activeIndex = newIndex;

      const leavingSlide = slides[previousIndex];
      const incomingSlide = slides[activeIndex];

      // Make sure incoming slide starts from the right edge with no transition,
      // in case it was just leaving or in some other state.
      if (incomingSlide) {
        clearResetTimer(incomingSlide);
        incomingSlide.classList.remove('product-carousel__slide--leaving');
        if (!incomingSlide.classList.contains('product-carousel__slide--active')) {
          incomingSlide.classList.add('product-carousel__slide--reset');
          void incomingSlide.offsetWidth;
          incomingSlide.classList.remove('product-carousel__slide--reset');
        }
      }

      slides.forEach((s, i) => {
        if (i === activeIndex) {
          s.classList.add('product-carousel__slide--active');
        } else {
          s.classList.remove('product-carousel__slide--active');
        }
      });

      if (leavingSlide && leavingSlide !== incomingSlide) {
        leavingSlide.classList.add('product-carousel__slide--leaving');
        clearResetTimer(leavingSlide);
        const timer = setTimeout(() => {
          resetTimers.delete(leavingSlide);
          snapToRight(leavingSlide);
        }, TRANSITION_MS);
        resetTimers.set(leavingSlide, timer);
      }

      bgSlides.forEach((b, i) => b.classList.toggle('product-carousel__section-bg-slide--active', i === activeIndex));
      thumbnails.forEach((t, i) => t.classList.toggle('product-carousel__thumbnail--active', i === activeIndex));

      scrollThumbnailIntoView(activeIndex);
      restartAutoplay();
    }

    function restartAutoplay() {
      if (autoplayTimer != null) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
      if (ageGatePending()) return;
      if (totalSlides <= 1) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (document.hidden) return;
      autoplayTimer = window.setInterval(() => {
        goToSlide(activeIndex + 1);
      }, AUTOPLAY_MS);
    }

    function startAutoplayWithDelay(ms) {
      if (autoplayDelayTimer != null) clearTimeout(autoplayDelayTimer);
      autoplayDelayTimer = setTimeout(() => {
        autoplayDelayTimer = null;
        restartAutoplay();
      }, ms);
    }

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        if (autoplayTimer != null) {
          clearInterval(autoplayTimer);
          autoplayTimer = null;
        }
      } else {
        restartAutoplay();
      }
    });

    thumbnails.forEach((thumb, i) => {
      thumb.addEventListener('click', () => goToSlide(i));
    });

    prevBtn?.addEventListener('click', () => goToSlide(activeIndex - 1));
    nextBtn?.addEventListener('click', () => goToSlide(activeIndex + 1));

    if (ageGatePending()) {
      const observer = new MutationObserver(() => {
        if (html.classList.contains('age-verified')) {
          observer.disconnect();
          startAutoplayWithDelay(6000);
        }
      });
      observer.observe(html, { attributes: true, attributeFilter: ['class'] });
    } else {
      restartAutoplay();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["verification"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const panel = document.getElementById('cyphemeSection');
    const btnCypheme = document.getElementById('btnCypheme');

    function showCypheme() {
      if (panel) {
        panel.classList.add('is-visible');
        panel.setAttribute('aria-hidden', 'false');
      }
      if (btnCypheme) btnCypheme.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(function () {}, function () {}, { timeout: 5000 });
      }
      loadCypheme();
      const closeBtn = panel?.querySelector('[data-cypheme-close]');
      if (closeBtn) closeBtn.focus();
    }

    function hideCypheme() {
      if (panel) {
        panel.classList.remove('is-visible');
        panel.setAttribute('aria-hidden', 'true');
      }
      if (btnCypheme) btnCypheme.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      if (btnCypheme) btnCypheme.focus();
    }

    const cyphemeCustomerId = document.querySelector('.verification')?.dataset.cyphemeCustomerId || '139';
    let cyphemeLoaded = false;

    function loadCypheme() {
      if (cyphemeLoaded) return;
      cyphemeLoaded = true;
      const s = document.createElement('script');
      s.src = 'https://js.cypheme.com/webapp/v1';
      s.setAttribute('customer_id', cyphemeCustomerId);
      document.body.appendChild(s);
    }

    if (btnCypheme) {
      btnCypheme.addEventListener('click', showCypheme);
    }

    if (panel) {
      panel.querySelectorAll('[data-cypheme-close]').forEach(function (el) {
        el.addEventListener('click', hideCypheme);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!panel || !panel.classList.contains('is-visible')) return;
      hideCypheme();
    });

    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('cypheme') === '1') {
      showCypheme();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
